import React from "react";
import "../landing/TalentIntro.css";
const getCastingCallsUrl = () => {
  const role = localStorage.getItem("userRole");

  switch (role) {
    case "USER":
    case "ADMIN":
      return "/castingcalls";

    case "COMPANY":
    default:
      return "/casting-calls";
  }
};
const NonLoggedFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="footer-brand-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polygon points="10 8 16 12 10 16 10 8" />
            </svg>

            <span className="footer-brand-name">DIRECTSUBMIT</span>
          </div>

          <p className="footer-brand-desc">
            DirectSubmit is a nationwide casting notice listing service used by
            Casting Directors, Producers, and Content Creators to cast
            SAG-AFTRA, Actors’ Equity, and non-union Actors, Models, Dancers,
            Singers, Voice-Over Artists, and Live Performers. Casting in New
            York, Los Angeles, Atlanta, Chicago, Miami, Seattle, Las Vegas,
            Texas, Knoxville, Boston, and across the United States.
            <br />
            <br />
            For over 26 years, DirectSubmit (formerly NYCastings.com) has
            connected performers with legitimate casting professionals
            nationwide.
          </p>

          <div className="footer-socials">
            <a
              href="https://www.facebook.com/NationwideActingAuditions"
              className="footer-social"
              aria-label="Facebook"
             
              rel="noopener noreferrer"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>

            <a
              href="https://www.instagram.com/directsubmitofficial/"
              className="footer-social"
              aria-label="Instagram"
             
              rel="noopener noreferrer"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">FOR TALENT</h4>

          <a href={getCastingCallsUrl()}>Browse Casting Calls</a>
          <a href="/talent-tour">Talent Tour</a>
          <a href="/signup">Join as Talent</a>
          <a href="https://www.nycastings.com/acting-advice/" target="_blank">Industry Advice</a>
          <a href="https://www.nycastings.com/monologues-for-actors/" target="_blank">Actor Monologues</a>
          <a href="https://www.nycastings.com/nycastings-success-stories-and-reviews/" target="_blank">Success Stories</a>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">FOR CASTING</h4>

          <a href="/post-casting-call">Post a Casting Call</a>
          <a href="/search">Search Talent</a>
          <a href="/director-tour">Casting Director Tour</a>
          <a href="/signup">Create Casting Account</a>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">RESOURCES</h4>

          <a href="/contact">Contact Us</a>
          <a href="/questions">Q & A</a>
          <a href="/about-directsubmit">About DirectSubmit</a>
          <a href="/terms-and-condition">Terms of Service</a>
          <a href="/privacy-policy">Privacy Policy</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-inclusion">
          DirectSubmit.com fosters a climate of purposeful inclusion and values
          diversity across race, religion, cultural identity, nationality,
          marital status, sexual orientation, gender identity and expression,
          family structure, age, mental and physical ability, political
          perspective, education, and socioeconomic background.
        </p>

        <p className="footer-copy">
          © 2000–2026 DirectSubmit.com. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default NonLoggedFooter;